'use strict'

var regexCheck = require('../util/regex-check.js')

var asciiAlphanumeric = regexCheck(/[\dA-Za-z]/)

module.exports = asciiAlphanumeric
